export default {
	title: 'WebHooks',
	links: [
		{
			title: 'Trips', href: '/docs/webhooks/trips',

		}
	],
}
